module.exports = __webpack_public_path__ + "img/money-flow.a021ad29.png";